import { BoxGeometry, Mesh, Material, Object3D, Vector3 } from 'three';

class BoxWithBottomOrigin {
  private mesh: Mesh;
  private geometry: BoxGeometry;


  constructor(width: number, height: number, depth: number, material?: Material, alignToZEdge:boolean=false) {
    this.geometry = new BoxGeometry(width, height, depth);
    this.mesh = new Mesh(this.geometry, material);

    // Shift the vertices to set the origin at the bottom of the box
    const positions = this.geometry.attributes.position.array as Float32Array;

    const yOffset = height / 2;
    const xOffet = alignToZEdge ? depth / 2 : 0;
    for (let i = 1; i < positions.length; i += 3) {  // i starts from 1 because the y-coordinates are at positions 1, 4, 7, ...
      positions[i] += yOffset;
      positions[i - 1] -= xOffet;
    }

    // Update the geometry to reflect the changes
    this.geometry.attributes.position.needsUpdate = true;
  }
  

  // Function to add this box to a parent Object3D (could be the scene or another object)
  addTo(parent: Object3D) {
    parent.add(this.mesh);
  }

  // Function to remove this box from a parent Object3D
  removeFrom(parent: Object3D) {
    parent.remove(this.mesh);
  }

  // Accessor to directly manipulate or query the mesh
  getMesh() {
    return this.mesh;
  }

  // Other functionalities you may need...
}

export default BoxWithBottomOrigin;